export default "https://kr-a.kakaopagecdn.com/web/qa/5.3.1/static/v4/404/img-not-found-light-v4-e84a613164747fef60543b69cfd21075.svg";